import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import "../fonts/breuer-headline.css";
import "./stage2_intro.css";
import { setBackButtonUrl } from "../uiSlice";

/**
 * Stage 2 entry after the spellcasting welcome game (`/welcome`).
 * Receives score/time from navigation state; extend this screen with the next game when ready.
 */
function Stage2Intro() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { wandId, houseId, characterId, points, time } = location.state ?? {};

  useEffect(() => {
    document.documentElement.classList.add("stage2-intro-static-bg");
    document.body.classList.add("stage2-intro-static-bg");
    return () => {
      document.documentElement.classList.remove("stage2-intro-static-bg");
      document.body.classList.remove("stage2-intro-static-bg");
    };
  }, []);

  useEffect(() => {
    dispatch(setBackButtonUrl("/welcome"));
  }, [dispatch]);

  if (!wandId) {
    return <Navigate to="/wand" replace />;
  }

  const goBroomFlight = () => {
    navigate("/stage2/broom", {
      state: {
        wandId,
        houseId,
        characterId,
        characterName: location.state?.characterName,
        wandName: location.state?.wandName,
        points: typeof points === "number" ? points : 0,
        time: time != null ? String(time) : "",
        reportId: location.state?.reportId,
        stageId: location.state?.stageId,
      },
    });
  };

  return (
    <div className="stage2-intro-page">
      <div className="stage2-intro-card">
        <h1>Stage 2</h1>
        <p>Your spellcasting trial is complete. The next chapter awaits.</p>
        <div className="stage2-intro-stats" aria-live="polite">
          <div className="stage2-intro-stat">
            <span>Score</span>
            <strong>{typeof points === "number" ? points : "—"}</strong>
          </div>
          <div className="stage2-intro-stat">
            <span>Time</span>
            <strong>{time != null && String(time).trim() !== "" ? String(time) : "—"}</strong>
          </div>
        </div>
        {houseId != null && characterId != null ? (
          <p className="stage2-intro-meta" style={{ fontSize: "0.85rem", opacity: 0.75 }}>
            House &amp; character data is carried forward for your next stage.
          </p>
        ) : null}
        <div className="stage2-intro-actions">
          <button type="button" className="stage2-intro-btn" onClick={goBroomFlight}>
            Begin broom flight
          </button>
        </div>
      </div>
    </div>
  );
}

export default Stage2Intro;
